var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.isConverted || _vm.isReservation)?_c('CUIcon',{staticClass:"text-primary w-24 h-24",attrs:{"view-box":"0 0 24 24"},on:{"click":_vm.unshare}},[_vm._v(" link_off ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }